<template>
  <div>
    <div class="google-map" ref="googleMap" :style="`height: ${innerHeight};`"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
        :markers="markers"
      />
    </template>
  </div>
</template>

<script>
// Original Google Map flight path curved bezier polyline code from mica's fiddle on jsfiddle.net:
// http://jsfiddle.net/mica/5o3w63uv/4/

// Fork from this example:
// http://jsfiddle.net/victorzn23/xsen0rma/4/

import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    markers: Array,
    innerHeight: {
      type: String,
      default: '500px'
    }
  },
  data () {
    return {
      google: null,
      map: null
    }
  },
  async mounted () {
    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ['geometry', 'places'],
      apiKey: this.apiKey
    })
    this.google = googleMapApi
    this.initializeMap()
    this.centerMap()
  },
  methods: {
    initializeMap () {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
    },
    centerMap () {
      var bounds = new this.google.maps.LatLngBounds()
      this.markers.forEach(marker => {
        bounds.extend(marker.position)
      })
      this.map.panToBounds(bounds)
      this.map.fitBounds(bounds)
    }
  }
}
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 100%;
  position: relative;
}
</style>
